'use client';

import { createContext, useContext, useEffect } from 'react';

type ThemeContextType = {
  theme: 'dark';
};

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

export function ThemeProvider({ children, attribute, defaultTheme, enableSystem }: { children: React.ReactNode; attribute?: string; defaultTheme?: string; enableSystem?: boolean }) {
  useEffect(() => {
    // Apply theme from localStorage or default
    const theme = localStorage.getItem('theme') || defaultTheme || 'dark';
    document.documentElement.setAttribute(attribute || 'class', theme);
  }, [attribute, defaultTheme]);

  return (
    <ThemeContext.Provider value={{ theme: 'dark' }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}